<template>
  <div style="height: 100%">
    <!-- 上面显示部分 -->
    <router-view></router-view>

    <!-- 下面两个按钮部分 -->
    <van-tabbar v-model="active" safe-area-inset-bottom fixed>
      <van-tabbar-item name="service" to="service">
        <span>服务</span>
        <template #icon="props">
          <img v-if="props.active" src="../assets/service_c_icon.png" />
          <img v-else src="@/assets/service_icon.png" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item name="mine" to="mine" icon="manager">
        <span>我的</span>
        <template #icon="props">
          <img v-if="props.active" src="../assets/mine_c_icon.png" />
          <img v-else src="@/assets/mine_icon.png" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: "",
    };
  },

  computed: {
    active: {
      get: function() {
        if (this.$route.path.indexOf("service") > -1) {
          return "service";
        } else {
          return "mine";
        }
      },
      set: function() {},
    },
  },
  created() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.van-tabbar-item__text {
  font-size: 20px;
}
</style>
